import mitt from 'mitt';
import type { SelectResponse } from '@/shared/types/api';

/** Ekran varlığı kaydı (DAL SystemHub ScreenPresence) — bir SignalR bağlantısı = bir kayıt. */
export interface PresenceUser {
  connectionId: string;
  userId: string;
  userCode: string;
  userName: string;
  /** Düzenlediği satırın anahtarı (KeyField değeri); düzenlemiyorsa null. */
  editingKey: string | null;
  editingSince: string | null;
}

/** SignalR olayları — hub'dan bağımsız tüketilir (useHubEvent). */
export type HubEvents = {
  /** Oturumu düşüren YENİ girişin cihaz bilgisi (UserSessions.ClientInfo); eski
   *  sunucular bilgiyi göndermiyor olabilir, o yüzden isteğe bağlı. */
  SessionExpired: string | undefined;
  MetadataChanged: string; // objectId
  RefreshNavigation: undefined;
  RefreshCalendar: undefined;
  RefreshGridData: string; // objectId
  UpdateData: { sessionId: string; objectId: string; response: SelectResponse };
  DeleteData: { sessionId: string; objectId: string; keyFieldValue: string };
  OpenReportTab: { reportActionId: string; caption: string; filterFieldValue: unknown; extra?: string };
  OpenReportDesigner: { reportId: number; caption: string };
  UpdateReportDesignerTabName: { reportId: number; oldName: string; newName: string };
  ScreenPresence: { objectId: string; users: PresenceUser[] };
  /** Başka bir bağlantı kayıt ekledi/güncelledi/sildi (refresh: toplu, anahtarsız). */
  RowsChanged: { objectId: string; kind: 'insert' | 'update' | 'delete' | 'refresh'; keys: string[] };
  EditConflict: { objectId: string; rowKey: string; user: PresenceUser };
  RowSaved: { objectId: string; rowKey: string; user: PresenceUser };
  /** Mesajlaşma (DAL ChatController sunucu yayınları) — yük tipleri features/chat/model/types. */
  ChatMessage: unknown;
  ChatMessageUpdated: unknown;
  ChatRead: { readerUserId: string; peerUserId: string | null; groupId: string | null; readAt: string };
  ChatTyping: { fromUserId: string; fromName: string; peerUserId: string | null; groupId: string | null };
  ChatReactions: { messageId: string; reactions: { emoji: string; userIds: string[] }[] };
  ChatGroupChanged: { groupId: string };
  /** Kullanıcı bildirimi (Sp_Rn_Sys_Notify / uygulama) — zil + uyarı. */
  NotificationReceived: unknown;
  ConnectionState: 'disconnected' | 'connecting' | 'connected' | 'reconnecting';
};

export const eventBus = mitt<HubEvents>();
